import { AppConfigModel } from "@/models/app-config/app-config.interface";
import { http } from "../http";
import { AxiosResponse } from "axios";

export class AppConfigAPI {
  private static INSTANCE = new AppConfigAPI();
  private appConfigNamespace = "config";
  static get instance() {
    return this.INSTANCE;
  }

  public getAppConfiguration(): Promise<AppConfigModel> {
    const endpoint = `${window.location.origin}/${this.appConfigNamespace}/${window.location.hostname}.json`;
    return http.get(endpoint).then(
      (response: AxiosResponse) => {
        return response.data;
      },
      () => Promise.resolve()
    );
  }
}

export const appConfigAPI = AppConfigAPI.instance;
